import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AuthenticationService, HttpService, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';

import BaseController from '../BaseController';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import TokenConstants from '../../constants/TokenConstants';
import { PatientTermServiceApi } from '@philips-emr/patient-components/src';
import { FetchAPI, ModalAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { OnSubmitTermUse } from '../../app/events';
import { TermsOfUseType } from '../../constants/terms-of-use-type';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import ApplicationTermService from '../../services/application-term-service';

@Controller({ component: 'assign-terms-modal', fragment: 'terms-of-use' })
class AssignTermsOfUseController extends BaseController {

  @Inject('terms-fetch')
    fetchTermoUso!: FetchAPI;

  @Inject('patient.terms.use')
    checkTerm!: PatientTermServiceApi;

  @Inject('panel-term')
    panelTerm!: PanelAPI;

  @OnMount({ target: ['assign-terms-modal'] })
  onMount(event: MountEvent): void {
    const nrSeqTermo = this.getHistoryRouteParam<Value>('nrSeqTermo');
    const termType = this.getHistoryRouteParam<Value>('termType');
    if(!Object.values(TermsOfUseType).includes(termType as TermsOfUseType)) {
      this.panelTerm.setVisible(false);
      return;
    }

    const modal = event.target as ModalAPI;
    switch(termType) {
      case TermsOfUseType.TERM_OF_USE:
        modal.setTitle('patient.terms.use');
        this.checkTerm.setLabel('patient.terms.use');
        break;
      case TermsOfUseType.TERM_OF_CONSENT:
        modal.setTitle('patient.terms.consent');
        this.checkTerm.setLabel('patient.terms.consent');
        break;
    }

    this.context.set({ nrSeqTermo, termType });
    const nrSeqValid = nrSeqTermo !== 'undefined';
    this.checkTerm.setEnabled(nrSeqValid);
    if (nrSeqValid) {
      this.fetchTermoUso.forceFetch();
    }
  }

  @OnClose({ target: ['assign-terms-modal'] })
  onclose(): void {
    AuthenticationService.logout();
  }

  @OnSubmitTermUse('patient.terms.use')
  onSubmitTermUse(): void {
    const nrSeqTermo = this.getHistoryRouteParam<Value>('nrSeqTermo');
    if (nrSeqTermo !== 'undefined') {
      HttpService.put(APPLICATION_ENDPOINTS.UPDATE_TERMS_OF_USE, { nrSeqTermo }).then(() => {
        ApplicationTermService.hasSignedRequiredConsents().then(() => {
          const token = AuthenticationService.getJWTToken() as JWTToken;
          const patientId: string = token.claims[TokenConstants.PATIENT_ID] as string;
          const params = { patientId };
          this.historyService.push(APPLICATION_ROUTES.HOME_DASHBOARD, params)
        })
      });
    }
  }
}

export default AssignTermsOfUseController;
